// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import { ERROR_LOG_SERVICE_CONFIGURATION } from './constants/error.service.constants';
// Types
import { ErrorType } from '../types/error.type';

const errorLogService = async ({ error }: ErrorType): Promise<[null, Response]> =>
  apiUtils.post({ ...ERROR_LOG_SERVICE_CONFIGURATION, params: { description: error } });

export { errorLogService };
